<template>
	<div class="parts-locations-general-card-edit">
		<Textarea
			label="Repair Order"
			:cols="30"
			:maxLength="1500"
			v-model="localData.extendedService"
		/>
		<Textarea
			label="Vehicle Inspection"
			:cols="30"
			:maxLength="1500"
			v-model="localData.vehicleInspectionDisclaimer"
		/>
		<Textarea
			label="Work Order"
			:cols="30"
			:maxLength="1500"
			v-model="localData.workOrderDisclaimer"
		/>
		<Textarea
			label="Estimate"
			:cols="30"
			:maxLength="1500"
			v-model="localData.estimateDisclaimer"
		/>
	</div>
</template>

<script>
import Textarea from '@/components/forms/textarea/textarea.vue';
import _ from 'lodash';

export default {
	name: 'PartsLocationsGeneralCardEdit',
	components: { Textarea },
	props: {
		value: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			localData: _.cloneDeep(this.value)
		};
	},
	created() {
		//console.log(this.value);
	},
	watch: {
		localData: {
			deep: true,
			handler() {
				this.$emit('update', this.localData);
				this.$emit('input', this.localData);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.parts-locations-general-card-edit {
	&__item {
		display: block;
	}
}
</style>
